import Vue from 'vue'
import VueRouter from 'vue-router'
import Aniversary from '../views/Aniversary.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Aniversary',
    component: Aniversary,
    meta: { title: '愛知県知的障害者福祉協会 60周年記念ページ', desc: '愛知県知的障害者福祉協会 60周年記念ページ'}
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
